import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CE6DC9C1-A636-4B3E-B838-34069330D3B2
 * name fullscreen-exit
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fullscreen-exit.svg
 * tags
 */
export const FullscreenExitIcon = createSvgIcon(<><path d="M14,14H19V16H16V19H14V14M5,14H10V19H8V16H5V14M8,5H10V10H5V8H8V5M19,8V10H14V5H16V8H19Z" /></>, 'FullscreenExitIcon');
export default FullscreenExitIcon